import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectImage extends PageObject {
  image: string;
  size: string;
  positionHorizontal: string;
  positionVertical: string;
  border: boolean;

  constructor(obj: PageObjectImage = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Image;

    if (obj == null) {
      this.image = "";
      this.size = "cover";
      this.positionHorizontal = "center";
      this.positionVertical = "center";
      this.border = true;
    } else {
      this.image = obj.image;
      this.size = obj.size;
      this.positionHorizontal = obj.positionHorizontal;
      this.positionVertical = obj.positionVertical;
      this.border = obj.border;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Image", OBJECTPROPERTYTYPE.Text));
    let size = new ObjectProperty("Size", OBJECTPROPERTYTYPE.List);
    size.addOption("initial", "100%");
    size.addOption("contain", "Contain");
    size.addOption("cover", "Cover");
    list.push(size);
    let positionHorizontal = new ObjectProperty("Horizontal", OBJECTPROPERTYTYPE.List);
    positionHorizontal.addOption("center", "Center");
    positionHorizontal.addOption("left", "Left");
    positionHorizontal.addOption("right", "Right");
    list.push(positionHorizontal);
    let positionVertical = new ObjectProperty("Vertical", OBJECTPROPERTYTYPE.List);
    positionVertical.addOption("center", "Center");
    positionVertical.addOption("top", "Top");
    positionVertical.addOption("bottom", "Bottom");
    list.push(positionVertical);
    let border = new ObjectProperty("Border", OBJECTPROPERTYTYPE.List);
    border.addOption("true", "Yes");
    border.addOption("false", "No");
    list.push(border);

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Image") {
      return this.image;
    } else if (name == "Size") {
      return this.size;
    } else if (name == "Horizontal") {
      return this.positionHorizontal;
    } else if (name == "Vertical") {
      return this.positionVertical;
    } else if (name == "Border") {
      return this.border ? "true" : "false";
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Image") {
      this.image = value;
    } else if (name == "Size") {
      this.size = value;
    } else if (name == "Horizontal") {
      this.positionHorizontal = value;
    } else if (name == "Vertical") {
      this.positionVertical = value;
    } else if (name == "Border") {
      this.border = value == "true";
    }
  }
}
